import script from "./AgregarIndicadoresView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgregarIndicadoresView.vue?vue&type=script&lang=ts&setup=true"

import "./AgregarIndicadoresView.vue?vue&type=style&index=0&id=99549310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99549310"]])

export default __exports__